// Browser/server console tags the RC activity TUI can parse: [feature/event]
// No optional chaining — gui Babel does not support it.

export function logFeature(feature, event, message, meta) {
  const extra = meta || {}
  const line = "[" + feature + "/" + event + "] " + message
  if (typeof console !== "undefined" && console.info) {
    console.info(line, extra)
  }
}
